import { useState, useEffect, useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import { People } from "@material-ui/icons";
import Button from "./../components/CustomButtons/Button";
import CustomInput from "./../components/CustomInput/CustomInput";
import GridContainer from "./../components/Grid/GridContainer.js";
import GridItem from "./../components/Grid/GridItem.js";
import Card from "./../components/Card/Card.js";
import CardBody from "./../components/Card/CardBody.js";
import CardHeader from "./../components/Card/CardHeader.js";
import CardFooter from "./../components/Card/CardFooter.js";
import styles from "../assets/style/login";
import { authAPI } from "../services/AuthService";
import Swal from "sweetalert2";
import { checkPasswordStrength } from "../utils/config.js";

const useStyles = makeStyles(styles);

const ForgetPasswordByID = (props) => {
  const { _id } = useParams();
  const [cardAnimaton, setCardAnimation] = useState("cardHidden");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [loading, setLoading] = useState(false);
  const checkStrong = useMemo(
    () => checkPasswordStrength(password),
    [password]
  );
  let history = useHistory();

  useEffect(() => {
    setLoading(true);
    authAPI
      .forgetPasswordByID(_id)
      .then((res) => {
        if (res.status != 200) throw { message: res.message };
      })
      .catch(async (err) => {
        Swal.fire({
          icon: "error",
          confirmButtonColor: "#f27474",
          html: `<span class="colorWhite">${err.message}</span>`,
          backdrop: "transparent",
          background: "rgba(0,0,0,.75)",
          customClass: {
            icon: "switch",
          },
          width: "28rem",
          timer: 3000,
        }).then(() => {
          history.push("/forget-password");
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [_id]);

  const PasswordFunction = async (e) => {
    e.preventDefault();
    const { isConfirmed } = await Swal.fire({
      title: "คุณแน่ใจ ?",
      text: "ยืนยันการเปลี่ยนรหัสผ่าน",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#56A834",
      cancelButtonColor: "#d33",
      confirmButtonText: "แน่ใจ",
      cancelButtonText: "ยังก่อน",
    });
    if (!isConfirmed) return;
    setLoading(true);
    authAPI
      .ResetPassword({
        _id,
        newPassword: password,
        confirmPassword: rePassword,
      })
      .then(async (res) => {
        if (res.status == 200) {
          await Swal.fire({
            icon: "success",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">เปลี่ยนรหัสผ่านสำเร็จ</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            width: "28rem",
            timer: 3000,
          });
          history.push("/login");
        } else {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${res.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 3000,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          confirmButtonColor: "#f27474",
          html: `<span class="colorWhite">${error.message}</span>`,
          backdrop: "transparent",
          background: "rgba(0,0,0,.75)",
          customClass: {
            icon: "switch",
          },
          width: "28rem",
          timer: 3000,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    document.title = "Com7 Merchandise - ยืนยันเปลี่ยนรหัสผ่าน";
    let mytimeout = setTimeout(() => {
      setCardAnimation("");
    }, 700);
    return () => {
      clearTimeout(mytimeout);
    };
  }, []);

  const classes = useStyles();

  return (
    <div onSubmit={PasswordFunction}>
      <div
        className={classes.pageHeader}
        style={{
          backgroundSize: "cover",
          backgroundPosition: "top center",
        }}
      >
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={4}>
              <Card
                className={classes[cardAnimaton]}
                style={{ borderRadius: "10px" }}
              >
                <form className={classes.form}>
                  <CardHeader color="primary" className={classes.cardHeader}>
                    <h3>Merchandise Messenger</h3>
                  </CardHeader>
                  <p className={classes.divider}>
                    โปรดยืนยันรหัสผ่านใหม่ของคุณ
                  </p>
                  <CardBody>
                    <CustomInput
                      values={password}
                      setValues={setPassword}
                      labelText="Password..."
                      id="password"
                      type="password"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "password",
                        endAdornment: (
                          <InputAdornment position="end">
                            <People className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <CustomInput
                      values={rePassword}
                      setValues={setRePassword}
                      labelText="Re Password..."
                      id="re-password"
                      type="password"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        type: "password",
                        endAdornment: (
                          <InputAdornment position="end">
                            <People className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </CardBody>
                  {!!password &&
                    (password != rePassword || !!checkStrong.length) && (
                      <div
                        style={{
                          backgroundColor: "#fef2f2",
                          border: "1px solid #fca5a5",
                          color: "#b91c1c",
                          padding: "16px",
                          borderRadius: "8px",
                          maxWidth: "400px",
                          fontFamily: "sans-serif",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "bold",
                            marginBottom: "8px",
                          }}
                        >
                          🚫 รหัสผ่านของคุณไม่ปลอดภัย:
                        </div>
                        <ul
                          style={{
                            paddingLeft: "20px",
                            margin: 0,
                          }}
                        >
                          {password != rePassword && (
                            <li
                              style={{
                                marginBottom: "6px",
                              }}
                            >
                              รหัสผ่านไม่ตรงกัน
                            </li>
                          )}
                          {checkStrong.map((res) => (
                            <li
                              key={`password-err-${res}`}
                              style={{
                                marginBottom: "6px",
                              }}
                            >
                              {res}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  <CardFooter
                    className={classes.cardFooter}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                    }}
                  >
                    <Button
                      className={classes.cardButton}
                      simple
                      type="submit"
                      color={`${
                        password != rePassword ||
                        !!checkStrong.length ||
                        loading
                          ? "danger"
                          : "primary"
                      }`}
                      style={{
                        borderRadius: "15px",
                        boxShadow: `0 5px 5px -50px ${
                          password != rePassword ||
                          !!checkStrong.length ||
                          loading
                            ? "lightgray"
                            : "#6ab23a"
                        }, 0 2px 15px -5px ${
                          password != rePassword ||
                          !!checkStrong.length ||
                          loading
                            ? "lightgray"
                            : "#6ab23a"
                        },0 12px 20px -10px ${
                          password != rePassword ||
                          !!checkStrong.length ||
                          loading
                            ? "lightgray"
                            : "#6ab23a"
                        }`,
                      }}
                      size="lg"
                      disabled={
                        password != rePassword ||
                        !!checkStrong.length ||
                        loading
                      }
                      onClick={PasswordFunction}
                    >
                      ยืนยัน
                    </Button>
                    <Button
                      className={classes.cardButton}
                      simple
                      type="button"
                      color={"primary"}
                      size="lg"
                      disabled={loading}
                      onClick={() => history.push("/forget-password")}
                    >
                      กลับ
                    </Button>
                  </CardFooter>
                </form>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
};
export default ForgetPasswordByID;
